import React, { useState } from 'react';
import { api, ApiError } from './api';
import { longDate } from './dates';
import { AP_DISTRICTS } from './editions';
import { Modal } from './Modal';
import { EditionMap } from './types';

/** Admin: type the page on which each district's news starts in this day's paper. */
export function EditionsDialog({ date, pageCount, current, onClose, onSaved }: { date: string; pageCount: number; current: EditionMap; onClose: () => void; onSaved: (m: EditionMap) => void }) {
  const [vals, setVals] = useState<Record<string, string>>(() => Object.fromEntries(AP_DISTRICTS.map((d) => [d, current[d] ? String(current[d]) : ''])));
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const save = async () => {
    const out: EditionMap = {};
    for (const d of AP_DISTRICTS) {
      const t = vals[d].trim();
      if (!t) continue;
      const n = parseInt(t, 10);
      if (!n || n < 1 || n > pageCount) return setErr(`${d}: enter a page from 1 to ${pageCount}, or leave it empty.`);
      out[d] = n;
    }
    setBusy(true);
    setErr('');
    try {
      onSaved(await api.setEditions(date, out));
      onClose();
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Could not save.');
      setBusy(false);
    }
  };

  return (
    <Modal title="District pages" onClose={onClose}>
      <p className="muted">
        For {longDate(date)} ({pageCount} pages): the page where each district's news starts. Leave a district empty if it is not in this paper.
      </p>
      <div className="ed-grid">
        {AP_DISTRICTS.map((d) => (
          <label key={d} className="ed-row">
            <span>{d}</span>
            <input
              value={vals[d]}
              inputMode="numeric"
              aria-label={d + ' page'}
              onChange={(e) => setVals({ ...vals, [d]: e.target.value.replace(/\D/g, '').slice(0, 3) })}
            />
          </label>
        ))}
      </div>
      {err && <p className="error">{err}</p>}
      <div className="actions">
        <button className="btn" onClick={onClose}>
          Cancel
        </button>
        <button className="btn primary" onClick={save} disabled={busy}>
          {busy ? 'Saving…' : 'Save'}
        </button>
      </div>
    </Modal>
  );
}
